import React from 'react';
import './PatentDiagrams.css';

// System Architecture Diagram
export const SystemArchitectureDiagram = () => {
  return (
    <div className="diagram-container">
      <h3>System Architecture</h3>
      <svg viewBox="0 0 800 500" className="diagram-svg">
        {/* Title */}
        <text x="400" y="30" textAnchor="middle" fontSize="18" fontWeight="bold" fill="#333">
          Interactive Visual Pattern Selection System Architecture
        </text>

        {/* Pattern Decomposition Engine */}
        <rect x="50" y="80" width="140" height="80" rx="5" fill="#667eea" stroke="#333" strokeWidth="2"/>
        <text x="120" y="110" textAnchor="middle" fontSize="12" fontWeight="bold" fill="white">
          Pattern Decomposition
        </text>
        <text x="120" y="130" textAnchor="middle" fontSize="11" fill="white">
          Engine
        </text>
        <text x="120" y="150" textAnchor="middle" fontSize="9" fill="white">
          Separator Detection
        </text>

        {/* Interactive Visual Selection Interface */}
        <rect x="250" y="80" width="140" height="80" rx="5" fill="#4caf50" stroke="#333" strokeWidth="2"/>
        <text x="320" y="110" textAnchor="middle" fontSize="12" fontWeight="bold" fill="white">
          Interactive Visual
        </text>
        <text x="320" y="130" textAnchor="middle" fontSize="11" fill="white">
          Selection Interface
        </text>
        <text x="320" y="150" textAnchor="middle" fontSize="9" fill="white">
          Numbered Parts
        </text>

        {/* Pattern Learning Module */}
        <rect x="450" y="80" width="140" height="80" rx="5" fill="#ff9800" stroke="#333" strokeWidth="2"/>
        <text x="520" y="110" textAnchor="middle" fontSize="12" fontWeight="bold" fill="white">
          Pattern Learning
        </text>
        <text x="520" y="130" textAnchor="middle" fontSize="11" fill="white">
          Module
        </text>
        <text x="520" y="150" textAnchor="middle" fontSize="9" fill="white">
          Structural Patterns
        </text>

        {/* Structural Pattern Matching Engine */}
        <rect x="250" y="220" width="140" height="80" rx="5" fill="#9c27b0" stroke="#333" strokeWidth="2"/>
        <text x="320" y="250" textAnchor="middle" fontSize="12" fontWeight="bold" fill="white">
          Structural Pattern
        </text>
        <text x="320" y="270" textAnchor="middle" fontSize="11" fill="white">
          Matching Engine
        </text>
        <text x="320" y="290" textAnchor="middle" fontSize="9" fill="white">
          Structure-Based
        </text>

        {/* Batch Application Engine */}
        <rect x="450" y="220" width="140" height="80" rx="5" fill="#f44336" stroke="#333" strokeWidth="2"/>
        <text x="520" y="250" textAnchor="middle" fontSize="12" fontWeight="bold" fill="white">
          Batch Application
        </text>
        <text x="520" y="270" textAnchor="middle" fontSize="11" fill="white">
          Engine
        </text>
        <text x="520" y="290" textAnchor="middle" fontSize="9" fill="white">
          Pattern Application
        </text>

        {/* Domain-Agnostic Processing Layer */}
        <rect x="50" y="220" width="140" height="80" rx="5" fill="#00bcd4" stroke="#333" strokeWidth="2"/>
        <text x="120" y="250" textAnchor="middle" fontSize="12" fontWeight="bold" fill="white">
          Domain-Agnostic
        </text>
        <text x="120" y="270" textAnchor="middle" fontSize="11" fill="white">
          Processing Layer
        </text>
        <text x="120" y="290" textAnchor="middle" fontSize="9" fill="white">
          Multi-Domain
        </text>

        {/* Arrows */}
        <path d="M 190 120 L 250 120" stroke="#333" strokeWidth="2" markerEnd="url(#arrowhead)"/>
        <path d="M 390 120 L 450 120" stroke="#333" strokeWidth="2" markerEnd="url(#arrowhead)"/>
        <path d="M 320 160 L 320 220" stroke="#333" strokeWidth="2" markerEnd="url(#arrowhead)"/>
        <path d="M 390 260 L 450 260" stroke="#333" strokeWidth="2" markerEnd="url(#arrowhead)"/>
        <path d="M 190 260 L 250 260" stroke="#333" strokeWidth="2" markerEnd="url(#arrowhead)"/>

        {/* Arrow marker definition */}
        <defs>
          <marker id="arrowhead" markerWidth="10" markerHeight="10" refX="9" refY="3" orient="auto">
            <polygon points="0 0, 10 3, 0 6" fill="#333"/>
          </marker>
        </defs>

        {/* Input/Output labels */}
        <text x="50" y="70" fontSize="12" fontWeight="bold" fill="#333">Input: Data String</text>
        <text x="590" y="260" fontSize="12" fontWeight="bold" fill="#333">Output: Normalized Data</text>
      </svg>
    </div>
  );
};

// Method Flow Diagram
export const MethodFlowDiagram = () => {
  return (
    <div className="diagram-container">
      <h3>Method Flow (8 Steps)</h3>
      <svg viewBox="0 0 900 700" className="diagram-svg">
        {/* Title */}
        <text x="450" y="30" textAnchor="middle" fontSize="18" fontWeight="bold" fill="#333">
          Interactive Visual Pattern Selection Method Flow
        </text>

        {/* Step 1 */}
        <rect x="50" y="60" width="150" height="60" rx="5" fill="#e3f2fd" stroke="#2196f3" strokeWidth="2"/>
        <text x="125" y="85" textAnchor="middle" fontSize="11" fontWeight="bold" fill="#1976d2">Step 1</text>
        <text x="125" y="105" textAnchor="middle" fontSize="10" fill="#1976d2">Data Input & Analysis</text>

        {/* Step 2 */}
        <rect x="250" y="60" width="150" height="60" rx="5" fill="#e8f5e9" stroke="#4caf50" strokeWidth="2"/>
        <text x="325" y="85" textAnchor="middle" fontSize="11" fontWeight="bold" fill="#2e7d32">Step 2</text>
        <text x="325" y="105" textAnchor="middle" fontSize="10" fill="#2e7d32">Separator Detection</text>

        {/* Step 3 */}
        <rect x="450" y="60" width="150" height="60" rx="5" fill="#fff3e0" stroke="#ff9800" strokeWidth="2"/>
        <text x="525" y="85" textAnchor="middle" fontSize="11" fontWeight="bold" fill="#e65100">Step 3</text>
        <text x="525" y="105" textAnchor="middle" fontSize="10" fill="#e65100">Visual Presentation</text>

        {/* Step 4 */}
        <rect x="650" y="60" width="150" height="60" rx="5" fill="#f3e5f5" stroke="#9c27b0" strokeWidth="2"/>
        <text x="725" y="85" textAnchor="middle" fontSize="11" fontWeight="bold" fill="#6a1b9a">Step 4</text>
        <text x="725" y="105" textAnchor="middle" fontSize="10" fill="#6a1b9a">Interactive Selection</text>

        {/* Step 5 */}
        <rect x="50" y="180" width="150" height="60" rx="5" fill="#e0f2f1" stroke="#009688" strokeWidth="2"/>
        <text x="125" y="205" textAnchor="middle" fontSize="11" fontWeight="bold" fill="#00695c">Step 5</text>
        <text x="125" y="225" textAnchor="middle" fontSize="10" fill="#00695c">Pattern Extraction</text>

        {/* Step 6 */}
        <rect x="250" y="180" width="150" height="60" rx="5" fill="#fce4ec" stroke="#e91e63" strokeWidth="2"/>
        <text x="325" y="205" textAnchor="middle" fontSize="11" fontWeight="bold" fill="#880e4f">Step 6</text>
        <text x="325" y="225" textAnchor="middle" fontSize="10" fill="#880e4f">Pattern Validation</text>

        {/* Step 7 */}
        <rect x="450" y="180" width="150" height="60" rx="5" fill="#fff8e1" stroke="#ffc107" strokeWidth="2"/>
        <text x="525" y="205" textAnchor="middle" fontSize="11" fontWeight="bold" fill="#f57f17">Step 7</text>
        <text x="525" y="225" textAnchor="middle" fontSize="10" fill="#f57f17">Batch Application</text>

        {/* Step 8 */}
        <rect x="650" y="180" width="150" height="60" rx="5" fill="#e1f5fe" stroke="#03a9f4" strokeWidth="2"/>
        <text x="725" y="205" textAnchor="middle" fontSize="11" fontWeight="bold" fill="#01579b">Step 8</text>
        <text x="725" y="225" textAnchor="middle" fontSize="10" fill="#01579b">Data Update</text>

        {/* Arrows */}
        <path d="M 200 90 L 250 90" stroke="#333" strokeWidth="2" markerEnd="url(#arrowhead)"/>
        <path d="M 400 90 L 450 90" stroke="#333" strokeWidth="2" markerEnd="url(#arrowhead)"/>
        <path d="M 600 90 L 650 90" stroke="#333" strokeWidth="2" markerEnd="url(#arrowhead)"/>
        <path d="M 725 120 L 725 180" stroke="#333" strokeWidth="2" markerEnd="url(#arrowhead)"/>
        <path d="M 650 210 L 600 210" stroke="#333" strokeWidth="2" markerEnd="url(#arrowhead)"/>
        <path d="M 400 210 L 450 210" stroke="#333" strokeWidth="2" markerEnd="url(#arrowhead)"/>
        <path d="M 200 210 L 250 210" stroke="#333" strokeWidth="2" markerEnd="url(#arrowhead)"/>

        {/* Arrow marker */}
        <defs>
          <marker id="arrowhead" markerWidth="10" markerHeight="10" refX="9" refY="3" orient="auto">
            <polygon points="0 0, 10 3, 0 6" fill="#333"/>
          </marker>
        </defs>

        {/* Example flow */}
        <rect x="50" y="300" width="750" height="350" rx="5" fill="#f5f5f5" stroke="#ccc" strokeWidth="1" strokeDasharray="5,5"/>
        <text x="425" y="325" textAnchor="middle" fontSize="14" fontWeight="bold" fill="#333">Example: "03 - The Monkees - I'm A Believer"</text>

        {/* Step 1 Example */}
        <text x="100" y="355" fontSize="11" fontWeight="bold" fill="#1976d2">Step 1:</text>
        <text x="100" y="375" fontSize="10" fill="#333">Input: "03 - The Monkees - I'm A Believer"</text>

        {/* Step 2 Example */}
        <text x="100" y="405" fontSize="11" fontWeight="bold" fill="#2e7d32">Step 2:</text>
        <text x="100" y="425" fontSize="10" fill="#333">Detected separator: " - "</text>
        <text x="100" y="445" fontSize="10" fill="#333">Parts: ["03", "The Monkees", "I'm A Believer"]</text>

        {/* Step 3 Example */}
        <text x="100" y="475" fontSize="11" fontWeight="bold" fill="#e65100">Step 3:</text>
        <rect x="100" y="485" width="80" height="30" rx="3" fill="#fff3e0" stroke="#ff9800" strokeWidth="1"/>
        <text x="140" y="503" textAnchor="middle" fontSize="9" fill="#e65100">[1] "03"</text>
        <rect x="200" y="485" width="120" height="30" rx="3" fill="#fff3e0" stroke="#ff9800" strokeWidth="1"/>
        <text x="260" y="503" textAnchor="middle" fontSize="9" fill="#e65100">[2] "The Monkees"</text>
        <rect x="340" y="485" width="140" height="30" rx="3" fill="#fff3e0" stroke="#ff9800" strokeWidth="1"/>
        <text x="410" y="503" textAnchor="middle" fontSize="9" fill="#e65100">[3] "I'm A Believer"</text>

        {/* Step 4 Example */}
        <text x="100" y="535" fontSize="11" fontWeight="bold" fill="#6a1b9a">Step 4:</text>
        <rect x="100" y="545" width="120" height="30" rx="3" fill="#f3e5f5" stroke="#9c27b0" strokeWidth="2"/>
        <text x="160" y="563" textAnchor="middle" fontSize="9" fill="#6a1b9a">[2] SELECTED</text>

        {/* Step 5 Example */}
        <text x="100" y="595" fontSize="11" fontWeight="bold" fill="#00695c">Step 5:</text>
        <text x="100" y="615" fontSize="10" fill="#333">Pattern: {`{separator: " - ", selectedParts: [2]}`}</text>

        {/* Step 6-8 Example */}
        <text x="100" y="640" fontSize="11" fontWeight="bold" fill="#333">Steps 6-8:</text>
        <text x="100" y="660" fontSize="10" fill="#333">Apply pattern to all records with structure "X - Y - Z"</text>
        <text x="100" y="680" fontSize="10" fill="#333">Output: "The Monkees" (extracted from part 2)</text>
      </svg>
    </div>
  );
};

// Pattern Learning Process Diagram
export const PatternLearningDiagram = () => {
  return (
    <div className="diagram-container">
      <h3>Pattern Learning Process</h3>
      <svg viewBox="0 0 700 400" className="diagram-svg">
        {/* Title */}
        <text x="350" y="30" textAnchor="middle" fontSize="18" fontWeight="bold" fill="#333">
          Pattern Learning from Visual Selection
        </text>

        {/* Input: User Selection */}
        <rect x="50" y="70" width="200" height="100" rx="5" fill="#e8f5e9" stroke="#4caf50" strokeWidth="2"/>
        <text x="150" y="95" textAnchor="middle" fontSize="12" fontWeight="bold" fill="#2e7d32">User Visual Selection</text>
        <text x="150" y="115" textAnchor="middle" fontSize="10" fill="#2e7d32">Selected Parts: [2]</text>
        <text x="150" y="135" textAnchor="middle" fontSize="10" fill="#2e7d32">From: "03 - The Monkees - I'm A Believer"</text>
        <text x="150" y="155" textAnchor="middle" fontSize="10" fill="#2e7d32">Separator: " - "</text>

        {/* Pattern Extraction */}
        <rect x="300" y="70" width="200" height="100" rx="5" fill="#fff3e0" stroke="#ff9800" strokeWidth="2"/>
        <text x="400" y="95" textAnchor="middle" fontSize="12" fontWeight="bold" fill="#e65100">Pattern Extraction</text>
        <text x="400" y="115" textAnchor="middle" fontSize="10" fill="#e65100">Structural Relationship:</text>
        <text x="400" y="135" textAnchor="middle" fontSize="10" fill="#e65100">"part 2 of 3"</text>
        <text x="400" y="155" textAnchor="middle" fontSize="10" fill="#e65100">Indices: [2]</text>

        {/* Pattern Storage */}
        <rect x="550" y="70" width="100" height="100" rx="5" fill="#e3f2fd" stroke="#2196f3" strokeWidth="2"/>
        <text x="600" y="95" textAnchor="middle" fontSize="12" fontWeight="bold" fill="#1976d2">Pattern</text>
        <text x="600" y="115" textAnchor="middle" fontSize="12" fontWeight="bold" fill="#1976d2">Storage</text>
        <text x="600" y="140" textAnchor="middle" fontSize="9" fill="#1976d2">JSON</text>
        <text x="600" y="155" textAnchor="middle" fontSize="9" fill="#1976d2">Metadata</text>

        {/* Arrows */}
        <path d="M 250 120 L 300 120" stroke="#333" strokeWidth="2" markerEnd="url(#arrowhead2)"/>
        <path d="M 500 120 L 550 120" stroke="#333" strokeWidth="2" markerEnd="url(#arrowhead2)"/>

        {/* Pattern Structure */}
        <rect x="50" y="220" width="600" height="150" rx="5" fill="#f5f5f5" stroke="#ccc" strokeWidth="1"/>
        <text x="350" y="245" textAnchor="middle" fontSize="14" fontWeight="bold" fill="#333">Stored Pattern Structure</text>
        
        <text x="70" y="270" fontSize="11" fill="#333" fontFamily="monospace">{`{`}</text>
        <text x="90" y="290" fontSize="10" fill="#333" fontFamily="monospace">"separator": " - ",</text>
        <text x="90" y="310" fontSize="10" fill="#333" fontFamily="monospace">"partCount": 3,</text>
        <text x="90" y="330" fontSize="10" fill="#333" fontFamily="monospace">"selectedParts": [2],</text>
        <text x="90" y="350" fontSize="10" fill="#333" fontFamily="monospace">"patternType": "single-part"</text>
        <text x="70" y="370" fontSize="11" fill="#333" fontFamily="monospace">{`}`}</text>

        {/* Arrow marker */}
        <defs>
          <marker id="arrowhead2" markerWidth="10" markerHeight="10" refX="9" refY="3" orient="auto">
            <polygon points="0 0, 10 3, 0 6" fill="#333"/>
          </marker>
        </defs>
      </svg>
    </div>
  );
};

// Structural Matching Diagram
export const StructuralMatchingDiagram = () => {
  return (
    <div className="diagram-container">
      <h3>Structural Pattern Matching</h3>
      <svg viewBox="0 0 800 500" className="diagram-svg">
        {/* Title */}
        <text x="400" y="30" textAnchor="middle" fontSize="18" fontWeight="bold" fill="#333">
          Structural vs. Content-Based Matching
        </text>

        {/* Original Pattern */}
        <rect x="50" y="70" width="300" height="120" rx="5" fill="#e8f5e9" stroke="#4caf50" strokeWidth="2"/>
        <text x="200" y="95" textAnchor="middle" fontSize="12" fontWeight="bold" fill="#2e7d32">Original Pattern</text>
        <text x="200" y="120" textAnchor="middle" fontSize="10" fill="#2e7d32">Input: "03 - The Monkees - I'm A Believer"</text>
        <text x="200" y="140" textAnchor="middle" fontSize="10" fill="#2e7d32">Structural Signature:</text>
        <text x="200" y="160" textAnchor="middle" fontSize="10" fontFamily="monospace" fill="#2e7d32">{`{separator: " - ", partCount: 3}`}</text>
        <text x="200" y="180" textAnchor="middle" fontSize="10" fill="#2e7d32">Selected: Part [2]</text>

        {/* Matching Records */}
        <rect x="400" y="70" width="350" height="120" rx="5" fill="#fff3e0" stroke="#ff9800" strokeWidth="2"/>
        <text x="575" y="95" textAnchor="middle" fontSize="12" fontWeight="bold" fill="#e65100">Matching Records (Structural Match)</text>
        <text x="575" y="120" textAnchor="middle" fontSize="10" fill="#e65100">✓ "01 - Beatles - Hey Jude" → "Beatles"</text>
        <text x="575" y="140" textAnchor="middle" fontSize="10" fill="#e65100">✓ "05 - Rolling Stones - Satisfaction" → "Rolling Stones"</text>
        <text x="575" y="160" textAnchor="middle" fontSize="10" fill="#e65100">✓ "12 - Queen - Bohemian Rhapsody" → "Queen"</text>
        <text x="575" y="180" textAnchor="middle" fontSize="10" fill="#e65100">All match: separator " - ", 3 parts</text>

        {/* Arrow */}
        <path d="M 350 130 L 400 130" stroke="#333" strokeWidth="3" markerEnd="url(#arrowhead3)"/>

        {/* Comparison Section */}
        <rect x="50" y="240" width="700" height="220" rx="5" fill="#f5f5f5" stroke="#ccc" strokeWidth="1"/>
        <text x="400" y="265" textAnchor="middle" fontSize="14" fontWeight="bold" fill="#333">Why Structural Matching is Novel</text>

        {/* Content-Based (Old Way) */}
        <rect x="70" y="280" width="320" height="160" rx="5" fill="#ffebee" stroke="#f44336" strokeWidth="2"/>
        <text x="230" y="305" textAnchor="middle" fontSize="12" fontWeight="bold" fill="#c62828">Content-Based Matching (Prior Art)</text>
        <text x="230" y="330" textAnchor="middle" fontSize="10" fill="#333">❌ Requires semantic analysis</text>
        <text x="230" y="350" textAnchor="middle" fontSize="10" fill="#333">❌ Needs domain knowledge</text>
        <text x="230" y="370" textAnchor="middle" fontSize="10" fill="#333">❌ Can't match across domains</text>
        <text x="230" y="390" textAnchor="middle" fontSize="10" fill="#333">❌ "The Monkees" ≠ "Beatles" (content)</text>
        <text x="230" y="410" textAnchor="middle" fontSize="10" fill="#333">❌ Fails to find similar patterns</text>
        <text x="230" y="430" textAnchor="middle" fontSize="10" fill="#333">❌ Requires training data</text>

        {/* Structural-Based (New Way) */}
        <rect x="410" y="280" width="320" height="160" rx="5" fill="#e8f5e9" stroke="#4caf50" strokeWidth="2"/>
        <text x="570" y="305" textAnchor="middle" fontSize="12" fontWeight="bold" fill="#2e7d32">Structural Matching (This Invention)</text>
        <text x="570" y="330" textAnchor="middle" fontSize="10" fill="#333">✓ Operates on structure only</text>
        <text x="570" y="350" textAnchor="middle" fontSize="10" fill="#333">✓ No domain knowledge needed</text>
        <text x="570" y="370" textAnchor="middle" fontSize="10" fill="#333">✓ Works across all domains</text>
        <text x="570" y="390" textAnchor="middle" fontSize="10" fill="#333">✓ " - " (3 parts) = " - " (3 parts)</text>
        <text x="570" y="410" textAnchor="middle" fontSize="10" fill="#333">✓ Finds all structurally similar</text>
        <text x="570" y="430" textAnchor="middle" fontSize="10" fill="#333">✓ No training data required</text>

        {/* Arrow marker */}
        <defs>
          <marker id="arrowhead3" markerWidth="10" markerHeight="10" refX="9" refY="3" orient="auto">
            <polygon points="0 0, 10 3, 0 6" fill="#333"/>
          </marker>
        </defs>
      </svg>
    </div>
  );
};

// UI Mockup Diagram
export const UIMockupDiagram = () => {
  return (
    <div className="diagram-container">
      <h3>User Interface Mockup</h3>
      <svg viewBox="0 0 700 400" className="diagram-svg">
        {/* Title */}
        <text x="350" y="30" textAnchor="middle" fontSize="18" fontWeight="bold" fill="#333">
          Interactive Visual Pattern Selection Interface
        </text>

        {/* Main UI Container */}
        <rect x="50" y="60" width="600" height="320" rx="5" fill="#ffffff" stroke="#333" strokeWidth="2"/>

        {/* Original Data Display */}
        <rect x="70" y="80" width="560" height="40" rx="3" fill="#f5f5f5" stroke="#ccc" strokeWidth="1"/>
        <text x="90" y="100" fontSize="11" fontWeight="bold" fill="#333">Original Data:</text>
        <text x="90" y="115" fontSize="12" fontFamily="monospace" fill="#333">"03 - The Monkees - I'm A Believer"</text>

        {/* Decomposed Parts */}
        <text x="90" y="150" fontSize="12" fontWeight="bold" fill="#333">Select Parts to Keep:</text>
        
        {/* Part 1 */}
        <rect x="90" y="165" width="150" height="50" rx="5" fill="#ffffff" stroke="#667eea" strokeWidth="2"/>
        <text x="165" y="185" textAnchor="middle" fontSize="10" fontWeight="bold" fill="#667eea">[1]</text>
        <text x="165" y="205" textAnchor="middle" fontSize="11" fill="#333">"03"</text>

        {/* Part 2 (Selected) */}
        <rect x="260" y="165" width="150" height="50" rx="5" fill="#4caf50" stroke="#2e7d32" strokeWidth="3"/>
        <text x="335" y="185" textAnchor="middle" fontSize="10" fontWeight="bold" fill="white">[2] ✓</text>
        <text x="335" y="205" textAnchor="middle" fontSize="11" fill="white">"The Monkees"</text>

        {/* Part 3 */}
        <rect x="430" y="165" width="150" height="50" rx="5" fill="#ffffff" stroke="#667eea" strokeWidth="2"/>
        <text x="505" y="185" textAnchor="middle" fontSize="10" fontWeight="bold" fill="#667eea">[3]</text>
        <text x="505" y="205" textAnchor="middle" fontSize="11" fill="#333">"I'm A Believer"</text>

        {/* Preview Section */}
        <rect x="70" y="240" width="560" height="60" rx="3" fill="#e8f5e9" stroke="#4caf50" strokeWidth="1"/>
        <text x="90" y="260" fontSize="11" fontWeight="bold" fill="#2e7d32">Preview:</text>
        <text x="90" y="280" fontSize="10" fill="#333">Original: "03 - The Monkees - I'm A Believer"</text>
        <text x="90" y="295" fontSize="10" fill="#2e7d32">Normalized: "The Monkees"</text>

        {/* Batch Info */}
        <rect x="70" y="320" width="560" height="40" rx="3" fill="#fff3cd" stroke="#ffc107" strokeWidth="1"/>
        <text x="90" y="340" fontSize="11" fill="#856404">📊 Pattern will be applied to 127 similar records</text>
        <text x="90" y="355" fontSize="10" fill="#856404">All records with structure: "X - Y - Z" (separator: " - ", 3 parts)</text>

        {/* Instructions */}
        <text x="350" y="385" textAnchor="middle" fontSize="10" fontStyle="italic" fill="#666">
          Click on numbered parts to select. Selected parts are highlighted in green.
        </text>
      </svg>
    </div>
  );
};

// Domain-Agnostic Application Diagram
export const DomainAgnosticDiagram = () => {
  return (
    <div className="diagram-container">
      <h3>Domain-Agnostic Application Across Industries</h3>
      <svg viewBox="0 0 900 600" className="diagram-svg">
        {/* Title */}
        <text x="450" y="30" textAnchor="middle" fontSize="18" fontWeight="bold" fill="#333">
          Same System, Multiple Domains - No Domain-Specific Programming Required
        </text>

        {/* Central System */}
        <rect x="350" y="80" width="200" height="100" rx="10" fill="#667eea" stroke="#333" strokeWidth="3"/>
        <text x="450" y="110" textAnchor="middle" fontSize="14" fontWeight="bold" fill="white">
          Interactive Visual
        </text>
        <text x="450" y="130" textAnchor="middle" fontSize="14" fontWeight="bold" fill="white">
          Pattern Selection
        </text>
        <text x="450" y="150" textAnchor="middle" fontSize="14" fontWeight="bold" fill="white">
          System
        </text>
        <text x="450" y="170" textAnchor="middle" fontSize="11" fill="white" fontStyle="italic">
          Domain-Agnostic
        </text>

        {/* Music Metadata */}
        <rect x="50" y="250" width="180" height="120" rx="5" fill="#e3f2fd" stroke="#2196f3" strokeWidth="2"/>
        <text x="140" y="275" textAnchor="middle" fontSize="12" fontWeight="bold" fill="#1976d2">🎵 Music Metadata</text>
        <text x="70" y="300" fontSize="10" fill="#333">Input: "03 - The Monkees - I'm A Believer"</text>
        <text x="70" y="320" fontSize="10" fill="#333">Separator: " - "</text>
        <text x="70" y="340" fontSize="10" fill="#333">Parts: [1] "03" | [2] "The Monkees" | [3] "I'm A Believer"</text>
        <text x="70" y="360" fontSize="10" fontWeight="bold" fill="#2e7d32">✓ Output: "The Monkees"</text>

        {/* Medical Billing */}
        <rect x="260" y="250" width="180" height="120" rx="5" fill="#ffebee" stroke="#f44336" strokeWidth="2"/>
        <text x="350" y="275" textAnchor="middle" fontSize="12" fontWeight="bold" fill="#c62828">🏥 Medical Billing</text>
        <text x="280" y="300" fontSize="10" fill="#333">Input: "E11.9 - Type 2 diabetes"</text>
        <text x="280" y="320" fontSize="10" fill="#333">Separator: " - "</text>
        <text x="280" y="340" fontSize="10" fill="#333">Parts: [1] "E11.9" | [2] "Type 2 diabetes"</text>
        <text x="280" y="360" fontSize="10" fontWeight="bold" fill="#2e7d32">✓ Output: "E11.9"</text>

        {/* Financial Data */}
        <rect x="470" y="250" width="180" height="120" rx="5" fill="#fff3e0" stroke="#ff9800" strokeWidth="2"/>
        <text x="560" y="275" textAnchor="middle" fontSize="12" fontWeight="bold" fill="#e65100">💰 Financial Data</text>
        <text x="490" y="300" fontSize="10" fill="#333">Input: "CHK-1234 - Bank Transfer"</text>
        <text x="490" y="320" fontSize="10" fill="#333">Separator: " - "</text>
        <text x="490" y="340" fontSize="10" fill="#333">Parts: [1] "CHK-1234" | [2] "Bank Transfer"</text>
        <text x="490" y="360" fontSize="10" fontWeight="bold" fill="#2e7d32">✓ Output: "CHK-1234"</text>

        {/* Customer Data */}
        <rect x="680" y="250" width="180" height="120" rx="5" fill="#e8f5e9" stroke="#4caf50" strokeWidth="2"/>
        <text x="770" y="275" textAnchor="middle" fontSize="12" fontWeight="bold" fill="#2e7d32">👤 Customer Data</text>
        <text x="700" y="300" fontSize="10" fill="#333">Input: "SMITH, JOHN M"</text>
        <text x="700" y="320" fontSize="10" fill="#333">Separator: ", "</text>
        <text x="700" y="340" fontSize="10" fill="#333">Parts: [1] "SMITH" | [2] "JOHN M"</text>
        <text x="700" y="360" fontSize="10" fontWeight="bold" fill="#2e7d32">✓ Output: "SMITH"</text>

        {/* Product Catalog */}
        <rect x="155" y="420" width="180" height="120" rx="5" fill="#f3e5f5" stroke="#9c27b0" strokeWidth="2"/>
        <text x="245" y="445" textAnchor="middle" fontSize="12" fontWeight="bold" fill="#6a1b9a">📦 Product Catalog</text>
        <text x="175" y="470" fontSize="10" fill="#333">Input: "SKU-ABC123 - Widget Pro"</text>
        <text x="175" y="490" fontSize="10" fill="#333">Separator: " - "</text>
        <text x="175" y="510" fontSize="10" fill="#333">Parts: [1] "SKU-ABC123" | [2] "Widget Pro"</text>
        <text x="175" y="530" fontSize="10" fontWeight="bold" fill="#2e7d32">✓ Output: "SKU-ABC123"</text>

        {/* Insurance Data */}
        <rect x="365" y="420" width="180" height="120" rx="5" fill="#e0f2f1" stroke="#009688" strokeWidth="2"/>
        <text x="455" y="445" textAnchor="middle" fontSize="12" fontWeight="bold" fill="#00695c">🛡️ Insurance Data</text>
        <text x="385" y="470" fontSize="10" fill="#333">Input: "POL-789 | Blue Cross | Active"</text>
        <text x="385" y="490" fontSize="10" fill="#333">Separator: " | "</text>
        <text x="385" y="510" fontSize="10" fill="#333">Parts: [1] "POL-789" | [2] "Blue Cross" | [3] "Active"</text>
        <text x="385" y="530" fontSize="10" fontWeight="bold" fill="#2e7d32">✓ Output: "POL-789"</text>

        {/* Address Data */}
        <rect x="575" y="420" width="180" height="120" rx="5" fill="#fff8e1" stroke="#ffc107" strokeWidth="2"/>
        <text x="665" y="445" textAnchor="middle" fontSize="12" fontWeight="bold" fill="#f57f17">📍 Address Data</text>
        <text x="595" y="470" fontSize="10" fill="#333">Input: "123 Main St, Anytown, CA 90210"</text>
        <text x="595" y="490" fontSize="10" fill="#333">Separator: ", "</text>
        <text x="595" y="510" fontSize="10" fill="#333">Parts: [1] "123 Main St" | [2] "Anytown" | [3] "CA 90210"</text>
        <text x="595" y="530" fontSize="10" fontWeight="bold" fill="#2e7d32">✓ Output: "123 Main St"</text>

        {/* Arrows from central system to each domain */}
        <path d="M 400 180 L 140 250" stroke="#667eea" strokeWidth="2" markerEnd="url(#arrowhead4)" strokeDasharray="5,5"/>
        <path d="M 450 180 L 350 250" stroke="#667eea" strokeWidth="2" markerEnd="url(#arrowhead4)" strokeDasharray="5,5"/>
        <path d="M 500 180 L 560 250" stroke="#667eea" strokeWidth="2" markerEnd="url(#arrowhead4)" strokeDasharray="5,5"/>
        <path d="M 450 180 L 770 250" stroke="#667eea" strokeWidth="2" markerEnd="url(#arrowhead4)" strokeDasharray="5,5"/>
        <path d="M 400 180 L 245 420" stroke="#667eea" strokeWidth="2" markerEnd="url(#arrowhead4)" strokeDasharray="5,5"/>
        <path d="M 450 180 L 455 420" stroke="#667eea" strokeWidth="2" markerEnd="url(#arrowhead4)" strokeDasharray="5,5"/>
        <path d="M 500 180 L 665 420" stroke="#667eea" strokeWidth="2" markerEnd="url(#arrowhead4)" strokeDasharray="5,5"/>

        {/* Key Point Box */}
        <rect x="50" y="80" width="250" height="100" rx="5" fill="#e8f5e9" stroke="#4caf50" strokeWidth="2"/>
        <text x="175" y="105" textAnchor="middle" fontSize="12" fontWeight="bold" fill="#2e7d32">Key Innovation</text>
        <text x="70" y="130" fontSize="10" fill="#333">✓ Same system works across</text>
        <text x="70" y="150" fontSize="10" fill="#333">✓ No domain-specific rules</text>
        <text x="70" y="170" fontSize="10" fill="#333">✓ Structural matching enables</text>
        <text x="70" y="190" fontSize="10" fill="#333">✓ Universal applicability</text>

        {/* Arrow marker */}
        <defs>
          <marker id="arrowhead4" markerWidth="10" markerHeight="10" refX="9" refY="3" orient="auto">
            <polygon points="0 0, 10 3, 0 6" fill="#667eea"/>
          </marker>
        </defs>

        {/* Bottom Note */}
        <text x="450" y="580" textAnchor="middle" fontSize="11" fontStyle="italic" fill="#666">
          All domains use the same visual pattern selection process - no programming or domain knowledge required
        </text>
      </svg>
    </div>
  );
};

// All Diagrams Component
export const AllPatentDiagrams = () => {
  return (
    <div className="all-diagrams-container">
      <SystemArchitectureDiagram />
      <MethodFlowDiagram />
      <PatternLearningDiagram />
      <StructuralMatchingDiagram />
      <UIMockupDiagram />
      <DomainAgnosticDiagram />
    </div>
  );
};

